import React from 'react'
import TextField from '@mui/material/TextField'

const ClearableTextField = ({ clear = false, value = '', onChange, ...props }) => {
  return (
    <TextField
      value={value}
      type="search"
      color="primary"
      onChange={onChange}
      placeholder="Text"
      {...props}
      InputProps={{
        style: {
          height: '36px',
        },
      }}
    />
  )
}

export default ClearableTextField
